// ฟังก์ชันช่วยเหลือสำหรับการจัดการข้อมูล
export const formatNumber = (value) => {
  if (!value && value !== 0) return "0.00";
  return new Intl.NumberFormat("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);
};

export const formatDate = (dateString) => {
  if (!dateString) return "";
  if (dateString.includes("/")) {
    return dateString;
  }

  const date = new Date(dateString);
  const day = date
    .getDate()
    .toString()
    .padStart(2, "0");
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
};

export const waitForPdfMakeReady = () => {
  return new Promise((resolve, reject) => {
    const checkInterval = setInterval(() => {
      if (typeof pdfMake !== "undefined" && pdfMake.vfs && pdfMake.fonts) {
        clearInterval(checkInterval);
        console.log("✅ pdfMake พร้อมใช้งาน พร้อมฟอนต์ภาษาไทย");
        resolve(true);
      }
    }, 100);

    setTimeout(() => {
      clearInterval(checkInterval);
      reject(new Error("pdfMake โหลดไม่สำเร็จ"));
    }, 10000);
  });
};

// ฟังก์ชันสร้างส่วนต่างๆ ของ Receipt
export class ReceiptPDFBuilder {
  constructor(data) {
    this.data = data;
    this.header = data.print_header || {};

    this.items = this.extractItems(data.datashowAll || []);
    this.currencyPrint = data.currency_print || "THB";
    this.exchangeRate = data.exchange_rate || 1;
    this.showCurrencyColumn = this.shouldShowCurrencyColumn();

    if (["D", "L"].includes(this.header.company_inv)) {
      this.header.com_eng_1 = this.header.com_eng_1 || "DEJ-UDOM & ASSOCIATES LTD.";
      this.header.com_eng_2 = this.header.com_eng_2 || "ATTORNEYS AT LAW";
      this.header.com_thai = this.header.com_thai || "บริษัท เดชอุดม แอนด์ แอสโซซิเอทส์ จำกัด";
      this.header.com_add_name = this.header.com_add_name || "CHARN ISSARA TOWER 1, 2nd FLOOR,";
      this.header.com_add_no = this.header.com_add_no || "942/69 RAMA IV ROAD,";
      this.header.com_add_city = this.header.com_add_city || "KWAENG SURIYAWONG, KHET BANGRAK,";
      this.header.com_add_country = this.header.com_add_country || "BANGKOK 10500, THAILAND";
      this.header.com_add_tel = this.header.com_add_tel || "Tel : 0-2233-0055, 0-2267-5152";
      this.header.com_add_email = this.header.com_add_email || "E-MAIL : account@dejudom.com";
      this.header.com_add_tax_id = this.header.com_add_tax_id || 'TAX ID. No. 0105534015348/"HEAD OFFICE"';

    } else {
      this.header.com_eng_1 = this.header.com_name || "ไม่มีข้อมูลบริษัท";
      this.header.com_eng_2 = this.header.com_eng_2 || "";
      this.header.com_thai = this.header.inv_company_name_th || "ไม่มีข้อมูลบริษัท";
      this.header.com_add_name = `${this.header.inv_company_address},` || " ";
      // this.header.com_add_no = `${this.header.inv_company_address2},`;
      if (this.header.inv_company_address2 && this.header.inv_company_address2 != "") {
        this.header.com_add_no = `${this.header.inv_company_address2},`;
      } else {
        this.header.com_add_no = ` `;
      }
      this.header.com_add_city = `${this.header.inv_subdistrict}, ${this.header.inv_subdistrict},`;
      this.header.com_add_country = `${this.header.inv_province}, ${this.header.inv_postcode}, ${this.header.inv_country}`;
      this.header.com_add_tel = `Tel : ${this.header.inv_company_tel}`;
      this.header.com_add_email = `E-MAIL : ${this.header.inv_company_email}`;
      this.header.com_add_tax_id = `TAX ID. No. ${this.header.inv_tax_id}/"${this.header.inv_company_branch}"`;

    }
  }

  extractItems(datashowAll) {
    const allItems = [];
    datashowAll.forEach((group) => {
      if (Array.isArray(group)) {
        group.forEach((item) => {
          allItems.push(item);
        });
      }
    });

    var lengthArr = allItems.length;
    // 👇 เพิ่ม row เปล่า 3 แถว
    for (let i = 0; i < 3; i++) {
      allItems.push({
        no: " ",
        description: "  ",
        quantity: 0,
        amount: 0
      });
    }
    return allItems;
  }

  shouldShowCurrencyColumn() {
    const curr = this.currencyPrint.toUpperCase();
    return curr !== "THB" && curr !== "THB";
  }

  createHeader() {
    return {
      columns: [
        {
          width: "50%",
          stack: [
            {
              text: this.header.com_eng_1,
              fontSize: 11,
              bold: true,
              margin: [0, 0, 0, 1],
            },
            {
              text: this.header.com_eng_2,
              fontSize: 8,
              bold: true,
              margin: [0, 0, 0, 1],
            },
            {
              text:
                this.header.com_thai,
              fontSize: 8,
              margin: [0, 0, 0, 1],
            },
          ],
        },
        {
          width: "50%",
          stack: [
            {
              text:
                this.header.com_add_name,
              fontSize: 7,
              alignment: "right",
              margin: [0, 0, 0, 1],
            },
            {
              text: this.header.com_add_no,
              fontSize: 7,
              alignment: "right",
              margin: [0, 0, 0, 1],
            },
            {
              text:
                this.header.com_add_city,
              fontSize: 7,
              alignment: "right",
              margin: [0, 0, 0, 1],
            },
            {
              text: this.header.com_add_country,
              fontSize: 7,
              alignment: "right",
              margin: [0, 0, 0, 1],
            },
            {
              text: this.header.com_add_tel,
              fontSize: 7,
              alignment: "right",
              margin: [0, 0, 0, 1],
            },
            {
              text: this.header.com_add_email,
              fontSize: 7,
              alignment: "right",
              margin: [0, 0, 0, 1],
            },
            {
              text:
                this.header.com_add_tax_id,
              fontSize: 7,
              alignment: "right",
              bold: true,
            },
          ],
        },
      ],
      margin: [0, 0, 0, -15],
    };
  }

  createTitle() {
    return {
      stack: [
        {
          text: this.header.com_title || "RECEIPT / TAX INVOICE",
          fontSize: 14,
          bold: true,
          alignment: "center",
          margin: [0, 15, 0, 2],
        },
        {
          text: this.header.com_title_th || "ใบเสร็จรับเงิน / ใบกำกับภาษี",
          fontSize: 12,
          bold: true,
          alignment: "center",
          margin: [0, 0, 0, 10],
        },
        {
          canvas: [
            {
              type: "line",
              x1: 0,
              y1: 0,
              x2: 515,
              y2: 0,
              lineWidth: 1,
            },
          ],
          margin: [0, 0, 0, 10],
        },
      ],
    };
  }

  createCustomerInfo() {
    const addressLines = (this.header.addressall || "").split("\n");
    const filteredAddress = addressLines
      .filter((line) => line.trim() !== "" && line.trim() !== ",")
      .join(", ");

    const rightColumnStack = [
      {
        text: `No. / เลขที่ : ${this.header.inv_id || "________"}`,
        fontSize: 9,
        alignment: "right",
        margin: [0, 0, 0, 5],
      },
      {
        text: `Date / วันที่ : ${formatDate(this.header.invoice_date) ||
          "______________"}`,
        fontSize: 9,
        alignment: "right",
        margin: [0, 0, 0, 5],
      },
    ];

    if (this.currencyPrint !== "THB") {
      rightColumnStack.push({
        text: `Exchange Rate : ${this.exchangeRate || "______________"}`,
        fontSize: 9,
        alignment: "right",
      });
    }

    return {
      columns: [
        {
          width: "70%",
          stack: [
            {
              columns: [
                {
                  width: 60,
                  text: "To / ถึง:",
                  fontSize: 9,
                },
                {
                  width: "*",
                  text: this.header.customer_name || "Customer Name",
                  fontSize: 9,
                  bold: true,
                },
              ],
              margin: [0, 0, 0, 3],
            },
            {
              columns: [
                {
                  width: 60,
                  text: "",
                  fontSize: 8,
                },
                {
                  width: "*",
                  text: filteredAddress || "Address",
                  fontSize: 8,
                },
              ],
              margin: [0, 0, 0, 3],
            },
            {
              columns: [
                {
                  width: 60,
                  text: "Tax ID:",
                  fontSize: 9,
                },
                {
                  width: "*",
                  text: `${this.header.customer_taxid ||
                    "__________________"}`,
                  fontSize: 9,
                },
              ],
            },
          ],
        },
        {
          width: "30%",
          stack: rightColumnStack,
        },
      ],
      margin: [0, 0, 0, 10],
    };
  }

  createFixTable() {
    const tableWidths = this.showCurrencyColumn
      ? [35, 244, 70, 80, 80]
      : [35, 325, 70, 80];
    return {
      stack: [
        // ตารางที่ 1: กรอบพื้นฐาน (ขอบและความสูงคงที่)
        {
          // absolutePosition: { x: 40, y: 243 },
          absolutePosition: { x: 40, y: -315 },
          layout: {
            hLineWidth: function (i, node) {
              if (i === 0 || i === 1) {
                return 1;
              }
              return 0;
            },
            vLineWidth: function (i) {
              return 1;
            },
            paddingLeft: function () {
              return 0;
            },
            paddingRight: function () {
              return 0;
            },
            paddingTop: function () {
              return 0;
            },
            paddingBottom: function () {
              return 0;
            },
          },
          margin: [0, 0, 0, 0],
          table: {
            headerRows: 1,
            widths: tableWidths,
            body: [
              // Header row
              [
                {
                  text: "No.",
                  fontSize: 9,
                  bold: true,
                  alignment: "center",
                  margin: [2, 3, 2, 3],
                },
                {
                  text: "Statement No./ เลขที่ใบเเจ้งหนี้",
                  fontSize: 9,
                  bold: true,
                  alignment: "center",
                  margin: [2, 3, 2, 3],
                },
                {
                  text: "Date / วันที่",
                  fontSize: 9,
                  bold: true,
                  alignment: "center",
                  margin: [2, 3, 2, 3],
                },
                ...(this.showCurrencyColumn ? [{
                  text: "Currency / Amount",
                  fontSize: 9,
                  bold: true,
                  alignment: "center",
                  margin: [2, 3, 2, 3],
                }] : []),
                {
                  text: "Amount / จำนวนเงิน",
                  fontSize: 9,
                  bold: true,
                  alignment: "center",
                  margin: [2, 3, 2, 3],
                },
              ],
              // แถวว่างสำหรับกำหนดความสูง
              [
                { text: '', margin: [5, 3, 5, 3] },
                { text: '', margin: [5, 3, 5, 3] },
                { text: '', margin: [5, 3, 5, 3] },
                ...(this.showCurrencyColumn ? [{ text: '', margin: [5, 3, 5, 3] }] : []),
                { text: '', margin: [5, 3, 5, 3] },
              ],
            ],
            heights: [25, 284]
          },
        },
      ],
    };
  }
  createlastFixTable() {
    const tableWidths = this.showCurrencyColumn
      ? [35, 244, 70, 80, 80]
      : [35, 325, 70, 80];
    return {
      stack: [
        // ตารางที่ 1: กรอบพื้นฐาน (ขอบและความสูงคงที่)
        {
          // absolutePosition: { x: 40, y: 243 },
          absolutePosition: { x: 40, y: -315 },
          layout: {
            hLineWidth: function (i, node) {
              if (i === 0 || i === 1) {
                return 1;
              }
              return 0;
            },
            vLineWidth: function (i) {
              return 1;
            },
            paddingLeft: function () {
              return 0;
            },
            paddingRight: function () {
              return 0;
            },
            paddingTop: function () {
              return 0;
            },
            paddingBottom: function () {
              return 0;
            },
          },
          margin: [0, 0, 0, 0],
          table: {
            headerRows: 1,
            widths: tableWidths,
            body: [
              // Header row
              [
                {
                  text: "No.",
                  fontSize: 9,
                  bold: true,
                  alignment: "center",
                  margin: [2, 3, 2, 3],
                },
                {
                  text: "Statement No./ เลขที่ใบเเจ้งหนี้",
                  fontSize: 9,
                  bold: true,
                  alignment: "center",
                  margin: [2, 3, 2, 3],
                },
                {
                  text: "Date / วันที่",
                  fontSize: 9,
                  bold: true,
                  alignment: "center",
                  margin: [2, 3, 2, 3],
                },
                ...(this.showCurrencyColumn ? [{
                  text: "Currency / Amount",
                  fontSize: 9,
                  bold: true,
                  alignment: "center",
                  margin: [2, 3, 2, 3],
                }] : []),
                {
                  text: "Amount / จำนวนเงิน",
                  fontSize: 9,
                  bold: true,
                  alignment: "center",
                  margin: [2, 3, 2, 3],
                },
              ],
              // แถวว่างสำหรับกำหนดความสูง
              [
                { text: '', margin: [5, 3, 5, 3] },
                { text: '', margin: [5, 3, 5, 3] },
                { text: '', margin: [5, 3, 5, 3] },
                ...(this.showCurrencyColumn ? [{ text: '', margin: [5, 3, 5, 3] }] : []),
                { text: '', margin: [5, 3, 5, 3] },
              ],
            ],
            heights: [25, 214]
          },
        },
      ],
    };
  }


  generateMainStatement(documentType = "ORIGINAL") {
    const mainContent = [];
    // ===== หน้าที่ 1 =====
    mainContent.push(
      // ตารางและข้อมูล
      this.generateItemsTable(this.items),
    );



    return mainContent;
  }


  generateItemsTable(items) {

    const tableWidthsBody = this.showCurrencyColumn
      ? [35, 230, 73, 69, 73]
      : [35, 310, 73, 70];

    return {
      stack: [
        // ตารางที่ 2: ข้อมูลจริง (วางทับ)
        {
          // absolutePosition: { x: 40, y: 268 }, // ต่ำกว่า header เล็กน้อย
          layout: {
            hLineWidth: function (i, node) {
              // if (i === 0 || i === 1) return 1;
              // if (i === node.table.body.length) return 1;
              return 0;
            },
            vLineWidth: function (i, node) {
              // return (i === 0 || i === 1 || i === node.table.widths.length) ? 1 : 0;
              return 0;
            },
            hLineColor: function (i, node) {
              return 'black';
            },
            vLineColor: function (i, node) {
              return 'black';
            }
          },
          layout: 'noBorders',
          margin: [0, 0, 0, 0],
          table: {
            widths: tableWidthsBody,
            body: [
              // [
              //   {
              //     text: '',
              //     fontSize: 10,
              //     bold: true,
              //     margin: [5, 5, 5, 5]
              //   },
              //   {
              //     text: '',
              //     fontSize: 10,
              //     bold: true,
              //     alignment: 'right',
              //     margin: [5, 5, 5, 5]
              //   },
              //   {
              //     text: '',
              //     fontSize: 10,
              //     bold: true,
              //     alignment: 'right',
              //     margin: [5, 5, 5, 5]
              //   },

              //   ...(this.showCurrencyColumn ? [{
              //     text: '',
              //     fontSize: 10,
              //     bold: true,
              //     alignment: 'right',
              //     margin: [5, 5, 5, 5]
              //   }] : []),
              //   {
              //     text: '',
              //     fontSize: 10,
              //     bold: true,
              //     alignment: 'right',
              //     margin: [5, 5, 5, 5]
              //   }
              // ],
              ...items.map(item => [
                {
                  text: item.no || (index + 1).toString(),
                  fontSize: 9,
                  alignment: "center",
                  margin: [0, 3, 0, 0],
                },
                {
                  text: item.inv_id || "",
                  fontSize: 9,
                  margin: [0, 3, 0, 0],
                },
                {
                  text: formatDate(item.date) || "",
                  fontSize: 9,
                  alignment: "center",
                  margin: [0, 3, 0, 0],
                },
                ...(this.showCurrencyColumn ? [{
                  text: item.amount ? formatNumber(item.amount) : "",
                  fontSize: 9,
                  alignment: "right",
                  margin: [0, 3, 0, 0],
                }] : []),
                {
                  text: item.amount_s_ex
                    ? formatNumber(item.amount_s_ex)
                    : item.amount_s
                      ? formatNumber(item.amount_s)
                      : "",
                  fontSize: 9,
                  alignment: "right",
                  margin: [0, 3, 0, 0],
                },
              ]),
            ],
            heights: (rowIndex) => {
              // if (rowIndex === 0) return 20;
              return 'auto';
            }

          },
        },
      ]
    };
  }

  createItemsTable() {
    const tableWidths = this.showCurrencyColumn
      ? [35, "*", 70, 80, 80]
      : [35, "*", 70, 80];

    const headerRow = [
      {
        text: "No.",
        fontSize: 9,
        bold: true,
        alignment: "center",
        margin: [2, 3, 2, 3],
      },
      {
        text: "Statement No./ เลขที่ใบเเจ้งหนี้",
        fontSize: 9,
        bold: true,
        alignment: "center",
        margin: [2, 3, 2, 3],
      },
      {
        text: "Date / วันที่",
        fontSize: 9,
        bold: true,
        alignment: "center",
        margin: [2, 3, 2, 3],
      },
    ];

    if (this.showCurrencyColumn) {
      headerRow.push({
        text: "Currency / Amount",
        fontSize: 9,
        bold: true,
        alignment: "center",
        margin: [2, 3, 2, 3],
      });
    }

    headerRow.push({
      text: "Amount / จำนวนเงิน",
      fontSize: 9,
      bold: true,
      alignment: "center",
      margin: [2, 3, 2, 3],
    });

    const bodyRows = [];
    const minRows = 7;

    for (let i = 0; i < this.items.length; i++) {
      if (i < this.items.length) {
        const item = this.items[i];
        const row = [
          {
            text: item.no || "",
            fontSize: 9,
            alignment: "center",
            margin: [2, 3, 2, 3],
          },
          {
            text: item.inv_id || "",
            fontSize: 9,
            margin: [2, 3, 2, 3],
          },
          {
            text: formatDate(item.date) || "",
            fontSize: 9,
            alignment: "center",
            margin: [2, 3, 2, 3],
          },
        ];

        if (this.showCurrencyColumn) {
          row.push({
            text: item.amount ? formatNumber(item.amount) : "",
            fontSize: 9,
            alignment: "right",
            margin: [2, 3, 2, 3],
          });
        }

        row.push({
          // text: item.amount_s ? formatNumber(item.amount_s) : "",
          // text: item.amount_s_ex ? formatNumber(item.amount_s_ex) : "",
          text: item.amount_s_ex
            ? formatNumber(item.amount_s_ex)
            : item.amount_s
              ? formatNumber(item.amount_s)
              : "",
          fontSize: 9,
          alignment: "right",
          margin: [2, 3, 2, 3],
        });

        bodyRows.push(row);
      } else {
        const emptyRow = [
          { text: "", fontSize: 9, margin: [2, 15, 2, 15] },
          { text: "", fontSize: 9, margin: [2, 15, 2, 15] },
          { text: "", fontSize: 9, margin: [2, 15, 2, 15] },
        ];

        if (this.showCurrencyColumn) {
          emptyRow.push({ text: "", fontSize: 9, margin: [2, 15, 2, 15] });
        }

        emptyRow.push({ text: "", fontSize: 9, margin: [2, 15, 2, 15] });
        bodyRows.push(emptyRow);
      }
    }

    return {
      table: {
        headerRows: 1,
        widths: tableWidths,
        body: [headerRow, ...bodyRows],
        layout: 'noBorders',
      },
      layout: {
        hLineWidth: function (i, node) {
          if (i === 0 || i === 1) {
            return 1;
          }
          return 0;
        },
        vLineWidth: function (i) {
          return 1;
        },
        paddingLeft: function () {
          return 0;
        },
        paddingRight: function () {
          return 0;
        },
        paddingTop: function () {
          return 0;
        },
        paddingBottom: function () {
          return 0;
        },
      },
      margin: [0, 0, 0, 0],
    };
  }

  createSummaryTable() {
    const subTotal = this.header.sub_total || 0;
    const subTotalOth = this.header.sub_total_oth || 0;
    const taxRate = this.header.tax_rate || "7.00";

    var taxAmount = this.header.tax_rate_amount || 0;
    var taxAmountOth = this.header.tax_rate_amount_oth || 0;

    var grandTotal = this.header.amount_total || 0;
    var grandTotalOth = this.header.amount_total_oth || 0;
    if (this.header.company_inv === "L") {
      grandTotal = subTotal;
      grandTotalOth = subTotalOth;
    }
    let currency = this.currencyPrint || "USD";
    currency = currency.replace("US", "USD").replace("USDD", "USD");

    const summaryWidths = this.showCurrencyColumn
      ? [35, 244, 70, 80, 80]
      : [35, 325, 70, 80];

    const summaryRows = [];

    const subTotalRow = [
      {
        text: "Sub Total / รวมเป็นเงิน",
        fontSize: 9,
        bold: true,
        alignment: "left",
        margin: [2, 3, 2, 3],
        colSpan: 3,
      },
      { text: "" },
      { text: "" },
    ];

    if (this.showCurrencyColumn) {
      subTotalRow.push({
        text: `${currency} ${formatNumber(subTotalOth)}`,
        fontSize: 9,
        alignment: "right",
        margin: [2, 3, 2, 3],
      });
    }

    subTotalRow.push({
      text: formatNumber(subTotal),
      fontSize: 9,
      alignment: "right",
      margin: [2, 3, 2, 3],
    });

    summaryRows.push(subTotalRow);

    if (this.header.company_inv != "L") {
      const vatRow = [
        {
          text: `Value Added Tax / ภาษีมูลค่าเพิ่ม (${taxRate} %)`,
          fontSize: 9,
          bold: true,
          alignment: "left",
          margin: [2, 3, 2, 3],
          colSpan: 3,
        },
        { text: "" },
        { text: "" },
      ];

      if (this.showCurrencyColumn) {
        vatRow.push({
          text: `${currency} ${formatNumber(taxAmountOth)}`,
          fontSize: 9,
          alignment: "right",
          margin: [2, 3, 2, 3],
        });
      }

      vatRow.push({
        text: formatNumber(taxAmount),
        fontSize: 9,
        alignment: "right",
        margin: [2, 3, 2, 3],
      });

      summaryRows.push(vatRow);
    }
    const grandTotalRow = [
      {
        text: "Grand Total / ยอดรวม",
        fontSize: 9,
        bold: true,
        alignment: "left",
        margin: [2, 3, 2, 3],
        colSpan: 3,
      },
      { text: "" },
      { text: "" },
    ];

    if (this.showCurrencyColumn) {
      grandTotalRow.push({
        text: `${currency} ${formatNumber(grandTotalOth)}`,
        fontSize: 9,
        bold: true,
        alignment: "right",
        margin: [2, 3, 2, 3],
      });
    }

    grandTotalRow.push({
      text: formatNumber(grandTotal),
      fontSize: 9,
      bold: true,
      alignment: "right",
      margin: [2, 3, 2, 3],
    });

    summaryRows.push(grandTotalRow);

    return {
      table: {
        widths: summaryWidths,
        body: summaryRows,
      },
      layout: {
        hLineWidth: function (i, node) {
          return 1;
        },
        vLineWidth: function (i) {
          return 1;
        },
        hLineColor: function () {
          return "black";
        },
        vLineColor: function () {
          return "black";
        },
        paddingLeft: function () {
          return 0;
        },
        paddingRight: function () {
          return 0;
        },
        paddingTop: function () {
          return 0;
        },
        paddingBottom: function () {
          return 0;
        },
      },
      margin: [0, -70, 0, 0],
    };
  }

  createAmountInWords() {
    const amountText = this.data.textamount_total_en || "";
    const checker_th = /([\u0E00-\u0E7F]+)/gmu;
    const isThaiCustomer = checker_th.test(this.header.customer_name || "");

    let displayText = "";
    if (isThaiCustomer) {
      displayText = `${amountText} `;
    } else {
      // displayText = `(${amountText}) ${this.currencyPrint || "THB"}`;
      displayText = `(${amountText}) THB`;
      displayText = displayText.replace("US", "USD").replace("USDD", "USD");
    }

    const widths = this.showCurrencyColumn
      ? [35, 244, 70, 80, 80]
      : [35, 325, 70, 80];

    const cells = [
      {
        text: displayText,
        fontSize: 9,
        alignment: "center",
        margin: [5, 8, 5, 8],
        fillColor: "#d8d8d8",
        colSpan: this.showCurrencyColumn ? 5 : 4,
      },
      {},
    ];

    const emptyCellCount = this.showCurrencyColumn ? 3 : 2;
    for (let i = 0; i < emptyCellCount; i++) {
      cells.push({});
    }

    return {
      table: {
        widths: widths,
        body: [cells],
      },
      layout: {
        hLineWidth: function () {
          return 0;
        },
        vLineWidth: function () {
          return 1;
        },
        hLineColor: function () {
          return "black";
        },
        vLineColor: function () {
          return "black";
        },
        paddingLeft: function () {
          return 0;
        },
        paddingRight: function () {
          return 0;
        },
        paddingTop: function () {
          return 0;
        },
        paddingBottom: function () {
          return 0;
        },
      },
      margin: [0, 0, 0, 0],
    };
  }

  createPaymentConditions() {
    const paymentBy = this.data.payment_by_print || "";
    const paymentDetail = this.header.payment_detail || "";

    const cashChecked = paymentBy === "Cash" || paymentBy === "cash";
    const transferChecked = paymentBy === "Transfer" || paymentBy === "Bank";
    const chequeChecked = paymentBy === "Cheque" || paymentBy === "cheque";

    return {
      table: {
        widths: [513],
        body: [
          [
            {
              stack: [
                {
                  text: "Payment Conditions:",
                  fontSize: 9,
                  bold: true,
                  margin: [2, 5, 2, 3],
                },
                {
                  columns: [
                    {
                      width: "auto",
                      canvas: cashChecked
                        ? [
                          {
                            type: "ellipse",
                            x: 5,
                            y: 5,
                            r1: 4,
                            r2: 4,
                            lineColor: "black",
                          },
                          {
                            type: "ellipse",
                            x: 5,
                            y: 5,
                            r1: 2,
                            r2: 2,
                            color: "black",
                          },
                        ]
                        : [
                          {
                            type: "ellipse",
                            x: 5,
                            y: 5,
                            r1: 4,
                            r2: 4,
                            lineColor: "black",
                          },
                        ],
                      margin: [10, 0, 5, 0],
                    },
                    {
                      width: "auto",
                      text: "Cash/เงินสด",
                      fontSize: 9,
                      margin: [0, 0, 20, 0],
                    },
                    {
                      width: "auto",
                      canvas: transferChecked
                        ? [
                          {
                            type: "ellipse",
                            x: 5,
                            y: 5,
                            r1: 4,
                            r2: 4,
                            lineColor: "black",
                          },
                          {
                            type: "ellipse",
                            x: 5,
                            y: 5,
                            r1: 2,
                            r2: 2,
                            color: "black",
                          },
                        ]
                        : [
                          {
                            type: "ellipse",
                            x: 5,
                            y: 5,
                            r1: 4,
                            r2: 4,
                            lineColor: "black",
                          },
                        ],
                      margin: [0, 0, 5, 0],
                    },
                    {
                      width: "auto",
                      text: "Transfer/โอนเงิน",
                      fontSize: 9,
                      margin: [0, 0, 20, 0],
                    },
                    {
                      width: "auto",
                      canvas: chequeChecked
                        ? [
                          {
                            type: "ellipse",
                            x: 5,
                            y: 5,
                            r1: 4,
                            r2: 4,
                            lineColor: "black",
                          },
                          {
                            type: "ellipse",
                            x: 5,
                            y: 5,
                            r1: 2,
                            r2: 2,
                            color: "black",
                          },
                        ]
                        : [
                          {
                            type: "ellipse",
                            x: 5,
                            y: 5,
                            r1: 4,
                            r2: 4,
                            lineColor: "black",
                          },
                        ],
                      margin: [0, 0, 5, 0],
                    },
                    {
                      width: "auto",
                      text: "Cheque/เช็คธนาคาร",
                      fontSize: 9,
                      margin: [0, 0, 20, 0],
                    },
                    {
                      width: "auto",
                      text:
                        (this.data.bank_name_show || "") +
                        "  No./เลขที่ : " +
                        (this.data.bank_no_show || ""),
                      fontSize: 9,
                    },
                  ],
                  margin: [2, 3, 2, 5],
                },
              ],
              margin: [2, 0, 2, 0],
            },
          ],
          [
            {
              text: `Payment Details / รายละเอียด:${paymentDetail ? "  " + paymentDetail : ""
                }`,
              fontSize: 9,
              margin: [2, 5, 2, 20],
            },
          ],
        ],
      },
      layout: {
        hLineWidth: function (i, node) {
          if (i === 0 || i === node.table.body.length) {
            return 1;
          }
          return 0;
        },
        vLineWidth: function () {
          return 1;
        },
        hLineColor: function () {
          return "black";
        },
        vLineColor: function () {
          return "black";
        },
        paddingLeft: function () {
          return 0;
        },
        paddingRight: function () {
          return 0;
        },
        paddingTop: function () {
          return 0;
        },
        paddingBottom: function () {
          return 0;
        },
      },
      margin: [0, 0, 0, 15],
    };
  }

  createSignatureBox() {
    return {
      columns: [
        {
          width: "50%",
          text: "",
        },
        {
          width: "50%",
          table: {
            widths: ["*"],
            body: [
              [
                {
                  stack: [
                    {
                      text: "",
                      margin: [0, 10, 0, 35],
                    },
                    {
                      canvas: [
                        {
                          type: "line",
                          x1: 30,
                          y1: 0,
                          x2: 200,
                          y2: 0,
                          lineWidth: 1,
                        },
                      ],
                      margin: [0, 0, 0, 5],
                    },
                    {
                      text: "Authorized Signature / ผู้รับเงิน",
                      fontSize: 9,
                      alignment: "center",
                      margin: [0, 0, 0, 10],
                    },
                    {
                      text: "Date/วันที่ _______________________",
                      fontSize: 9,
                      alignment: "center",
                      margin: [0, 0, 0, 10],
                    },
                  ],
                },
              ],
            ],
          },
          layout: {
            hLineWidth: function () {
              return 1;
            },
            vLineWidth: function () {
              return 1;
            },
            hLineColor: function () {
              return "black";
            },
            vLineColor: function () {
              return "black";
            },
          },
        },
      ],
      margin: [0, 0, 0, 15],
    };
  }

  createFooterNote() {
    return {
      stack: [
        {
          text:
            "This receipt will be valid when the company has received the payment into the bank account.",
          fontSize: 8,
          alignment: "center",
          margin: [0, 5, 0, 0],
        },
        {
          text:
            "ใบเสร็จรับเงินนี้จะสมบูรณ์เมื่อบริษัทได้รับชำระเงินเข้าในบัญชีธนาคารเรียบร้อยแล้ว",
          fontSize: 8,
          alignment: "center",
        },
      ],
      margin: [0, 10, 0, 0],
    };
  }

  build() {
    const content = [];
    // content.push(this.createHeader());
    // content.push(this.createTitle());
    // content.push(this.createCustomerInfo());
    //  content.push(this.generateItemsTable());  
    // content.push(this.createItemsTableFixBorder());
    // content.push(this.createItemsTable());
    // content.push(this.createSummaryTable());
    // content.push(this.createAmountInWords());
    // content.push(this.createPaymentConditions());
    // content.push(this.createSignatureBox());
    // content.push(this.createFooterNote());
    return content;
  }

  getDocDefinition() {
    const originalContent = this.generateMainStatement("ORIGINAL");
    return {
      pageSize: "A4",
      pageMargins: [40, 275, 40, 287],
      content: [...originalContent],
      header: (currentPage, pageCount) => {
        // แสดงในทุกหน้า (ลบ if condition ออก)
        return {
          stack: [
            this.createHeader(),
            this.createTitle(),
            this.createCustomerInfo(),

          ],
          margin: [40, 40, 40, 10],
        };
      },
      footer: (currentPage, pageCount) => {
        //  if(currentPage == 1){
        return {
          stack: [
            ...(currentPage === pageCount
              ?
              [

                this.createlastFixTable(),
                this.createSummaryTable(),
                this.createAmountInWords(),

                this.createPaymentConditions(),
                this.createSignatureBox(),
                this.createFooterNote()
              ] : [
                this.createFixTable(),
                this.createPaymentConditions(),
                this.createSignatureBox(),
                this.createFooterNote()
              ]
            ),
          ],
          margin: [40, 0, 40, 0],
        };
        // }
      },
      defaultStyle: {
        font: "Sarabun",
        fontSize: 10,
      },
    };
  }
}

// ฟังก์ชันหลักสำหรับสร้าง PDF
export const generateReceiptPDF = async (data) => {
  console.log("generateReceiptPDF")
  console.log(data)
  // console.log(`Generating receipt PDF with data:`, JSON.stringify(data));

  try {
    await waitForPdfMakeReady();
    const builder = new ReceiptPDFBuilder(data);
    const docDefinition = builder.getDocDefinition();
    pdfMake.createPdf(docDefinition).open();
    console.log("✅ สร้าง Receipt PDF สำเร็จ");
    return true;
  } catch (error) {
    console.error("❌ เกิดข้อผิดพลาดในการสร้าง PDF:", error);
    throw error;
  }
};
